export interface IUserInfoData {
    userName?: string;
    companyCode?: string;
    officeCode?: string;
    serviceType?: string;

}

export class UserInfo {
    userName?: string;
    companyCode?: string;
    officeCode?: string;
    serviceType?: string;

    constructor(data: IUserInfoData = {}) {
        this.userName = data.userName || "";
        this.companyCode = data.companyCode || "";
        this.officeCode = data.officeCode || "";
        this.serviceType = data.serviceType || "";
    }
}